export default "__VITE_ASSET__CD1NPJvs__"